import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  EditClosingField,
  LocationDetailResponse,
  Unit,
} from '../../shared/models/location-model/location.model';
import { LocationService } from '../../shared/services/location.service';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../../shared/services/general.service';
import { TableGeneralSimple } from '../../shared/components-generals/table-general-simple/table-general-simple';
import { MatTableDataSource } from '@angular/material/table';
import { TableGeneralComponent } from '../../shared/components-generals/table-general/table-general.component';
import { TicketService } from '../../shared/services/ticket.service';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { Ticket } from '../../shared/models/ticket-model/tiket.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-location-detail',
  imports: [
    MatButtonModule,
    TableGeneralSimple,
    TableGeneralComponent,
    LoadGeneralComponent,
    TranslateModule,
  ],
  templateUrl: './location-detail.html',
  styleUrl: './location-detail.css',
  standalone: true,
})
export class LocationDetail {
  public locationDetail: LocationDetailResponse | null = null;

  public installedUnitsDataSource = new MatTableDataSource<Unit>([]);
  public installedUnitsHeaders = [
    { value: 'SerialNumber', description: 'No. Serie' },
    { value: 'Brand', description: 'Marca' },
    { value: 'Model', description: 'Modelo' },
    { value: 'Description', description: 'Descripción' },
    { value: 'Responsible', description: 'Responsable' },
    { value: 'ConnectivityType', description: 'Tipo de Conectividad' },
  ];
  public id: string | null = null;
  public loadService = false;
  public editClosingField: EditClosingField[] | null = null;
  public headersField = [
    { value: 'Id', description: 'No.' },
    { value: 'WorkFlowId', description: 'ID Flujo' },
    { value: 'EditClosingFieldId', description: 'ID Campo Cierre' },
    { value: 'Description', description: 'Descripción' },
    { value: 'Value', description: 'Valor' },
  ];
  public dataSourceField = new MatTableDataSource<any>([]);

  public ticketsDataSource = new MatTableDataSource<Ticket>([]);
  public ticketsHeaders = [
    { value: 'Task', description: 'Tarea' },
    { value: 'TaskType', description: 'Tipo de Tarea' },
    { value: 'TicketState', description: 'Estado del Ticket' },
    { value: 'CreateDate', description: 'Fecha de Creación' },
    { value: 'CancelDate', description: 'Fecha de Cancelación' },
    { value: 'ClosingDate', description: 'Fecha de Cierre' },
    { value: 'WarrantyDate', description: 'Fecha de Garantía' },
    { value: 'Engineer', description: 'Ingeniero' },
    { value: 'LocationDescription', description: 'Descripción de la Ubicación' },
    { value: 'Priority', description: 'Tipo de Conexión' },
  ];

  constructor(
    private locationService: LocationService,
    private route: ActivatedRoute,
    private generalService: GeneralService,
    public ticketService: TicketService,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.id = params.get('id');
      if (this.id) {
        this.loadService = true;
        this.getLocationDetail(Number(this.id));
      }
    });
  }

  public getLocationDetail(id: number): void {
    const locationDetail = this.locationService.getLocationDetail(id);
    const editClosingField = this.locationService.LocationEditClosingField(id);

    this.generalService.getServices([locationDetail, editClosingField]).then((response) => {
      if (response) {
        this.locationDetail = (response[0]?.Data as LocationDetailResponse) || null;
        this.ticketSearch(this.locationDetail?.Key || '');
        if (
          this.locationDetail &&
          Array.isArray(this.locationDetail.InstalledUnits) &&
          this.locationDetail.InstalledUnits.length > 0
        ) {
          this.installedUnitsDataSource.data = this.locationDetail.InstalledUnits;
        } else {
          // Ejemplo de datos si InstalledUnits viene vacío
          this.installedUnitsDataSource.data = [
            {
              Id: 1,
              Description: 'Unidad de ejemplo',
              SerialNumber: 'SN-0001',
              Model: 'Modelo X',
              Brand: 'Marca Y',
              ResponsibleId: 123,
              Responsible: 'Responsable Demo',
              ResponsibleType: 'Tipo Demo',
              ConnectivityType: '4G',
            },
            {
              Id: 2,
              Description: 'Unidad de ejemplo 2',
              SerialNumber: 'SN-0002',
              Model: 'Modelo Z',
              Brand: 'Marca W',
              ResponsibleId: 456,
              Responsible: 'Responsable Demo 2',
              ResponsibleType: 'Tipo Demo',
              ConnectivityType: 'WiFi',
            },
          ];
        }

        this.editClosingField = response[1]?.Data as EditClosingField[];
        if (this.editClosingField && this.editClosingField.length) {
          this.dataSourceField.data = this.editClosingField;
        } else {
          // Ejemplo de datos si editClosingField viene vacío
          this.dataSourceField.data = [
            {
              Value: '455',
              Id: 12344,
              WorkFlowId: 0,
              EditClosingFieldId: 1,
              ParentClosingFieldId: null,
              ParentClosingFieldValue: null,
              ClosingFieldId: 0,
              IsMandatory: false,
              ComponentTypeId: 1,
              ComponentType: 'Texto',
              ComponentCatalogId: null,
              ComponentCatalog: null,
              Description: 'Instalación Existente',
              ValidationRegex: '',
              Annotation: null,
              Preffix: null,
              Suffix: null,
              Code: 0,
              Order: 1,
              ComponentCatalogFilterMap: null,
              Catalog: [],
            },
          ];
        }
      }
    });
  }

  public back(): void {
    window.history.back();
  }

  public ticketSearch(id: string): void {
    this.ticketService
      .ticketSearch({ SearchField: 'LocationKey', SearchFieldValue: id, Page: 1, PageSize: 9999 })
      .subscribe((response) => {
        if (response) {
          this.ticketsDataSource.data = response.Data.Items;
        }
        this.loadService = false;
      });
  }
}
